import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
const firebaseConfig = {
  apiKey: "AIzaSyD2VzK--C5XiJgw6Dcds1hUbnx3uCaceTM",
  authDomain: "uploadimagesfornewwebsite.firebaseapp.com",
  projectId: "uploadimagesfornewwebsite",
  storageBucket: "uploadimagesfornewwebsite.appspot.com",
  messagingSenderId: "36027026519",
  appId: "1:36027026519:web:bc2b1283560575f869a712"
};

const fireDb = firebase.initializeApp(firebaseConfig);
export default fireDb.database().ref();